<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">
                <app-i18n code="home.menu"></app-i18n>
            </el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/subproperty/list' }">
                <app-i18n code="entities.subproperty.menu"></app-i18n>
            </el-breadcrumb-item>
            <el-breadcrumb-item>
                <app-i18n code="entities.subproperty.view.title"></app-i18n>
            </el-breadcrumb-item>
        </el-breadcrumb>

        <div class="app-content-page">
            <h1 class="app-content-title app-content-title--hidden">
                <app-i18n code="entities.subproperty.view.title"></app-i18n>
            </h1>

            <div class="app-page-spinner" v-if="loading" v-loading="loading"></div>

            <app-subproperty-view-toolbar v-if="record"></app-subproperty-view-toolbar>

            <el-form
                :label-position="labelPosition"
                :label-width="labelWidthForm"
                @submit.prevent.native
                class="form"
                v-if="record"
            >
                <app-view-item-text :label="fields.id.label" :value="presenter(record, 'id')"></app-view-item-text>

                <app-view-item-text :label="fields.name.label" :value="presenter(record, 'name')"></app-view-item-text>

                <app-view-item-text :label="fields.sport.label" :value="presenter(record, 'sport')"></app-view-item-text>

                <app-view-item-custom
                    :label="fields.programs.label"
                    :value="presenter(record, 'programs')"
                >
                    <div :key="programId" v-for="programId in record.programs">
                        <el-tooltip :content="programDescriptionOf(programId)">
                            <span>{{ programLabelOf(programId) }}</span>
                        </el-tooltip>
                    </div>
                </app-view-item-custom>

                <app-view-item-relation-to-many
                    :label="fields.managers.label"
                    :permission="fields.managers.readPermission"
                    :url="fields.managers.viewUrl"
                    :value="presenter(record, 'managers')"
                ></app-view-item-relation-to-many>

                <app-view-item-image
                    :label="fields.logos.label"
                    :value="presenter(record, 'logos')"
                ></app-view-item-image>

                <app-view-item-custom
                    :label="fields.status.label"
                    :value="presenter(record, 'status')"
                >
                    <el-tag
                        :type="subpropertyStatusTagType(record['status'])"
                    >{{ presenter(record, 'status') }}</el-tag>
                </app-view-item-custom>

                <app-view-item-text
                    :label="fields.createdAt.label"
                    :value="presenter(record, 'createdAt')"
                ></app-view-item-text>

                <app-view-item-text
                    :label="fields.updatedAt.label"
                    :value="presenter(record, 'updatedAt')"
                ></app-view-item-text>
            </el-form>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Programs from '@modules/subproperty/subproperty-programs';
import SubpropertyViewToolbar from '@modules/subproperty/components/subproperty-view-toolbar.vue';
import { SubpropertyModel } from '@modules/subproperty/subproperty-model';
import { subpropertyStatusTagType } from '@modules/subproperty/subproperty-enum-status';
import { subpropertyAccessTagType } from '@modules/subproperty/subproperty-enum-access';

const { fields } = SubpropertyModel;

export default {
    name: 'app-subproperty-view-page',

    props: ['id'],

    components: {
        [SubpropertyViewToolbar.name]: SubpropertyViewToolbar,
    },

    computed: {
        ...mapGetters({
            labelPosition: 'layout/labelPosition',
            labelWidthForm: 'layout/labelWidthForm',
            record: 'subproperty/view/record',
            loading: 'subproperty/view/loading',
        }),

        fields() {
            return fields;
        },
    },

    async created() {
        await this.doFind(this.id);
    },

    methods: {
        ...mapActions({
            doFind: 'subproperty/view/doFind',
        }),

        presenter(record, fieldName) {
            return SubpropertyModel.presenter(
                record,
                fieldName,
            );
        },

        subpropertyStatusTagType(status) {
            return subpropertyStatusTagType(status);
        },

        subpropertyAccessTagType(status) {
            return subpropertyAccessTagType(status);
        },
        programDescriptionOf(programId) {
            return Programs.descriptionOf(programId);
        },

        programLabelOf(programId) {
            return Programs.labelOf(programId);
        },
    },
};
</script>
